import { __awaiter, __decorate, __extends, __generator } from "tslib";
import AvalonGTView from '@/utils/libs/BaseView';
import { Options } from 'vue-class-component';
import { PageService } from '@/views/copy/activity/import';
import { Toast } from 'vant';
import NavPanel from '@/components/common/NavPanel.vue';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.list = [
            {
                ttno: '用户ID',
                frozen_desc: '违规原因',
                result: '处理结果',
            },
        ];
        return _this;
    }
    View.prototype.created = function () {
        if (this.awlGlobalState.urlInitParams.bannerId) {
            this.getActivity();
        }
        this.getCleanNetAction();
    };
    View.prototype.getCleanNetAction = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, PageService.getCleanNetAction()];
                    case 1:
                        data = _a.sent();
                        this.list = this.list.concat(data);
                        return [2 /*return*/];
                }
            });
        });
    };
    // 2022/2/20 10:41 获取活动状态
    View.prototype.getActivity = function () {
        PageService.getActivityStatus({
            bannerId: this.awlGlobalState.urlInitParams.bannerId,
        }).then(function (data) {
            if (Number(data.activityStatus) != 1 && data.text) {
                Toast(data.text);
            }
        });
    };
    View = __decorate([
        Options({
            components: { NavPanel: NavPanel },
        })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
